<template>
  <div>
    <vx-card v-show="isNew && !confirmProto" class="product-proto" >
<!--      <h2 class="text-center mb-10 mt-10">溯源商品协议</h2>-->
      <div class="container">
        <Prot />
      </div>
      <div class="text-center mt-10">
        <div class="inline-block">
          <vs-checkbox v-model="accessProto"><span>我同意以上溯源商品协议</span></vs-checkbox>
        </div>

      </div>
      <div class="text-center mt-5">
        <vs-button class="mr-5" @click="confirmProtoBtn">确认</vs-button>
        <vs-button type="border" color="warning" to="/product/list">取消</vs-button>
      </div>
    </vx-card>
    <vx-card title="填写商品信息" v-show="!(isNew && !confirmProto)">
      <vx-form class="w-full" layout="v" label-align="top" v-slot="{handleSubmit}">
        <form-item label="商品图片" :msgs="{required: '请上传商品图片'}" help="商品图片将会显示在溯源页面中，图片尺寸规格会根据溯源页面模板而不同，为了更好的页面展示，请上传符合溯源模板尺寸的产品图片，图片格式支持 <b>.jpg,.png</b> 格式">
          <upload
            fileName="files"
            v-model="form.pictures"
            ref="upload"
            automatic
            multiple
            text="上传"
            accept=".jpg,.png"
            action="/admin/v1/file/upload/multiple"
            :singleUpload="false"
          />
        </form-item>
        <form-item label="所属客户" help="请选择该商品的所属客户，如果您不选择，商品默认分配到您的账户下，并且后期不可更改" v-if="$acl.check('customer_list') && isNew">
          <v-select :options="$s.user.customersAndMe()" label="userName" v-model="form.uid" :reduce="p => p.uid">
            <template v-slot:option="user">
              <span v-if="user.uid == $s.auth.user.uid">(我)</span>{{user.nickName}}[{{user.userName}}]【{{user.name}}】
            </template>
          </v-select>
        </form-item>
        <form-item v-else-if="$acl.check('customer_list')" label-align="none" label="所属客户">
          <span>{{user.nickName}}[{{user.userName}}]【{{user.name}}】</span>
        </form-item>
        <form-item required label="商品名称" :msgs="{required: '请填写商品名称'}" >
          <vs-input class="w-full" placeholder="商品名称" v-model="form.name" />
        </form-item>
        <form-item label="商品批号" label-align="none" help="启用批号功能后，同一个商品可存在多个不同批次的商品，每个批次可配置独立的溯源内容。如果不启用批号，该商品所有溯源码的溯源内容都相同">
          <vs-switch v-model="form.enableBatch"></vs-switch>
        </form-item>
        <form-item label="网店销售地址" help="网上销售的地址，在溯源页面可点击直达网上购买页面，如不填则不会再溯源页面显示">
          <vs-input class="w-full" v-model="form.saleSite" />
        </form-item>
        <form-item label="商品介绍地址" help="官网的产品介绍网址，如不填则不会再溯源页面显示">
          <vs-input class="w-full" v-model="form.saleAddr" />
        </form-item>
        <form-item label="商品简介" help="简单的介绍商品，建议填写商品标语">
          <vs-textarea class="w-full" v-model="form.desc" />
        </form-item>
        <form-item label="商品型号/规格" help="商品的型号规格，颜色、尺寸等，如不填则不会再溯源页面显示">
          <vs-input class="w-full" v-model="form.spec" />
        </form-item>
        <form-item label="服务承诺" help="如不填则不会再溯源页面显示">
          <vs-textarea class="w-full mb-0" v-model="form.promise" />
        </form-item>
        <form-item label="商品详情" help="详细描述商品的各种属性，功能，用途等，不建议填写溯源相关的内容">
          <editor class="w-full" v-model="form.content" />
        </form-item>
        <form-item>
          <vs-button class="mr-3 mb-2" @click="handleSubmit(submitForm)">提交</vs-button>
          <vs-button v-if="!isNew && product.id && !product.enableBatch" @click="toBatchDetail(product)" class="mr-2" type="border">编辑溯源</vs-button>
          <vs-button v-if="!isNew && product.id && product.enableBatch" @click="viewBatch(product)" class="mr-2" type="border">查看批号</vs-button>
          <vs-button color="warning" type="border" class="mb-2" to="/product/list">返回</vs-button>
        </form-item>
      </vx-form>
    </vx-card>
  </div>

</template>
<script>
  import Prot from './prot'
import Editor from '@/components/editor'

export default {
  components: {
    Editor,
    Prot,
  },

  data() {
    return {
      form: {

      },
      product: {},
      accessProto: true,
      confirmProto: false
    }
  },
  computed: {
    isNew() {
      return !this.$route.params.id
    },
    user() {
      return this.$s.user.customersAndMe().find(i => i.uid == this.form.uid) || {}
    }
  },
  async mounted() {
    this.$s.user.getCompany()
    this.form.uid = this.$s.auth.user.uid
    if (this.$acl.check('customer_list')) {
      this.$s.user.fetchCustomer()
    }

    if (!this.isNew) {
      this.product = await this.$s.product.detail(this.$route.params.id)
      this.form = {
        ...this.product,
      }
    }
  },
  methods: {
    confirmProtoBtn() {
      if (!this.accessProto) {
        this.$notify({
          color: 'danger',
          title: "请同意溯源商品协议"
        })
        return
      }
      this.confirmProto = true
    },
    async submitForm() {
      const data = {
        ...this.form,
        // pictures: this.pictures.filter(i => !i.remove).map(i => i.url),
      }
      let product = {...data}
      if (this.isNew) {
        const res = await this.$s.product.create(data).catch(err => {
          this.$notify({
            color: 'danger',
            title: '商品创建失败',
            text: '服务器发生错误，请稍后再试',
          })
          throw err
        })
        product = res.product
        this.$notify({
          title: '商品创建成功'
        })
      } else {
        await this.$s.product.update(data).catch(err => {
          this.$notify({
            color: 'danger',
            title: '商品修改失败',
            text: '服务器发生错误，请稍后再试',
          })
          throw err
        })
        this.$notify({
          title: '商品修改成功'
        })
      }
      if (!data.enableBatch && product.id) {
        this.toBatchDetail(product)
        return
      }
      this.$router.push('/product/list')
    },
    async toBatchDetail(product) {
      const batch = await this.$s.product.createBatchNo({
        productID: product.id,
        batchNo: '默认批号',
        isDefault: true,
      }).catch(err => {
        this.$notify({
          color: 'error',
          title: '默认批号生成失败',
        })
        throw err
      })
      this.$router.push('/batchno/detail/' + batch.id)
    },
    viewBatch() {
      this.$modal('batchList', {product: this.product})
    }
  }
}
</script>
<style lang="scss" scoped>
.product-proto {
  .vx-card__header {
    text-align: center;
  }
}
</style>